// extracted by mini-css-extract-plugin
export var people = "people-module--people--3PE_f";
export var headline = "people-module--headline--2GpMC";
export var copy = "people-module--copy--2BvUB";
export var videoCard = "people-module--videoCard--p2lVH";